import styled from 'styled-components';
import { fontFamilies } from '../../UI/Font';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const InsideWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px;
`;

export const TopWrapper = styled.div`
  display: flex;
  position: relative;
  margin: 0;
`;

export const HeaderWrapper = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
`;

export const Header = styled.h3`
  position: absolute;
  bottom: 0;
  margin: 0;
  line-height: 1;
`;

export const WarningContent = styled.p`
  margin-top: 10px;
  line-height: 1.5;
`;

export const Link = styled.a`
  font-family: ${fontFamilies.bold};
  text-decoration: underline;
`;
